"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalDestinationType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.ExternalDestinationType = {
    FBA: 'FBA',
    SMB: 'SMB',
    WALMART: 'WALMART',
    TARGET: 'TARGET',
    NORDSTROM: 'NORDSTROM',
    WHOLESALE: 'WHOLESALE',
    AMAZON_WAREHOUSE: 'AMAZON_WAREHOUSE',
    TRANSFER_ECOM: 'TRANSFER_ECOM',
    BED_BATH_BEYOND: 'BED_BATH_BEYOND',
    BEST_BUY: 'BEST_BUY',
    TUNDRA: 'TUNDRA',
    FAIRE: 'FAIRE',
    HATCH_NON_EDIS: 'HATCH_NON_EDIS',
    BASS_PRO: 'BASS_PRO',
    BABY_LIST: 'BABY_LIST',
    POTTERY_BARN_KIDS: 'POTTERY_BARN_KIDS',
    CONTAINER_STORE: 'CONTAINER_STORE',
    SPS: 'SPS'
};
//# sourceMappingURL=external-destination-type.js.map